import { AddToCartOrListState } from './state';
import { ListActionTarget } from '../../../models/ListActionTarget';
import { AddToCartOrListAction, CHANGE_TARGET, SET_TARGET_SELECTION_LIST_ID } from './types';

const initialState: AddToCartOrListState = {
    target: ListActionTarget.Cart,
    targetSelectionListId: undefined
};

export function addToCartOrListReducers(
    state: AddToCartOrListState = initialState,
    action: AddToCartOrListAction
): AddToCartOrListState {
    switch (action.type) {
        case CHANGE_TARGET: {
            return {
                ...state,
                target: action.target
            };
        }
        case SET_TARGET_SELECTION_LIST_ID:
            return {
                ...state,
                targetSelectionListId: action.selectionListId
            };
        default:
            return state;
    }
}
